import ability from "@/store/modules/ability";
import alertInformation from "@/store/modules/alertInformation";
import anteckningstyp from "@/store/modules/anteckningstyp";
import authModule from "@/store/modules/authModule";
import avtalModule from "@/store/modules/avtalModule";
import configModule from "@/store/modules/configModule";
import diagnoskodModule from "@/store/modules/diagnoskodModule";
import dictionary from "@/store/modules/dictionary";
import filhantering from "@/store/modules/filhantering";
import forsakringsbolagModule from "@/store/modules/forsakringsbolagModule";
import genomlysningsapparatModule from "@/store/modules/genomlysningsapparatModule";
import icdkod from "@/store/modules/icdkod";
import idle from "@/store/modules/idle";
import intyg from "@/store/modules/intyg";
import journalanteckningar from "@/store/modules/journalanteckningar";
import journalanteckningsmall from "@/store/modules/journalanteckningsmall";
import kallelsemallModule from "@/store/modules/kallelsemallModule";
import journalloggar from "@/store/modules/journalloggar";
import kvakod from "@/store/modules/kvakod";
import lakemedelModule from "@/store/modules/lakemedel/lakemedelModule";
import leverantorModule from "@/store/modules/leverantorModule";
import loginMode from "@/store/modules/loginMode";
import materialgruppModule from "@/store/modules/materialgruppModule";
import materialModule from "@/store/modules/materialModule";
import opCalendar from "@/store/modules/operation/operationskalender";
import resursModule from "@/store/modules/operation/resursModule";
import orgUnit from "@/store/modules/orgUnit";
import patientData from "@/store/modules/patientData";
import prescriptionSet from "@/store/modules/prescriptionSet";
import nllModule from "@/store/modules/recept/nllModule";
import receptforskrivningMallModule from "@/store/modules/recept/receptforskrivningMallModule";
import receptforskrivningModule from "@/store/modules/recept/receptforskrivningModule";
import samtycke from "@/store/modules/samtycke";
import skreg from "@/store/modules/skreg";
import slutenvardsbesokModule from "@/store/modules/slutenvardsbesokModule";
import sokord from "@/store/modules/sokord";
import systemData from "@/store/modules/systemData";
import tabs from "@/store/modules/tabList";
import triggersModule from "@/store/modules/triggersModule";
import typAvGenomlysningsapparatModule from "@/store/modules/typAvGenomlysningsapparatModule";
import userAdmin from "@/store/modules/userAdmin";
import userData from "@/store/modules/userData";
import vardplatsbestallningModule from "@/store/modules/vardplatsbestallningModule";
import vardplatsSparradTidModule from "@/store/modules/vardplatsSparradTidModule";
import Vue from "vue";
import Vuex from "vuex";
import operation from "./modules/operation";
import profileModule from "@/store/modules/profileModule";
import remiss from "@/store/modules/remiss";
import studieKvalitetsregisterModule from "@/store/modules/studieKvalitetsregisterModule";
import besokstypkodModule from "@/store/modules/oppenvard/besokstypkodModule";
import besokstypModule from "@/store/modules/oppenvard/besokstypModule";
import besoksmallModule from "@/store/modules/oppenvard/besoksmallModule";
import oppenvardsbesokModule from "@/store/modules/oppenvard/besokModule";

Vue.use(Vuex);

/**
 * NOTE: all modules registered here _must_ implement reset() mutation.
 */

const store = new Vuex.Store({
    modules: {
        prescriptionSet,
        patientData,
        userData,
        userAdmin,
        systemData,
        tabs,
        dictionary,
        journalanteckningar,
        alertInformation,
        samtycke,
        orgUnit,
        sokord,
        anteckningstyp,
        icdkod,
        kvakod,
        journalloggar,
        intyg,
        filhantering,
        resurs: resursModule,
        opCalendar,
        operation,
        skreg,
        journalanteckningsmall,
        kallelsemall: kallelsemallModule,
        ability,
        loginMode,
        idle,
        triggers: triggersModule,
        material: materialModule,
        leverantor: leverantorModule,
        materialgrupp: materialgruppModule,
        config: configModule,
        slutenvardsbesok: slutenvardsbesokModule,
        vardplatsbestallning: vardplatsbestallningModule,
        vardplatsSparradTid: vardplatsSparradTidModule,
        lakemedel: lakemedelModule,
        receptforskrivning: receptforskrivningModule,
        nll: nllModule,
        diagnoskod: diagnoskodModule,
        avtal: avtalModule,
        forsakringsbolag: forsakringsbolagModule,
        genomlysningsapparat: genomlysningsapparatModule,
        typAvGenomlysningsapparat: typAvGenomlysningsapparatModule,
        profile: profileModule,
        auth: authModule,
        remiss,
        studieKvalitetsregister: studieKvalitetsregisterModule,
        besokstypkod: besokstypkodModule,
        besokstyp: besokstypModule,
        besoksmall: besoksmallModule,
        oppenvardsbesok: oppenvardsbesokModule,
        receptforskrivningMall: receptforskrivningMallModule,
    },
    // Ta bort kommentar om du vill debugga Vuex lokalt
    // strict: true,
});

export default store;
export const useStore = () => store;
